import { getRoomLogs } from 'network/ApiAccomodation';
import React,{useState,useEffect} from 'react'
import { Row,Col,Accordion,AccordionBody,AccordionHeader,AccordionItem, } from 'reactstrap';

function RoomLogs(props) {
    useEffect(() => {
        fetchRoomLogs()
    }, []);

    const [open, setOpen] = useState('');
    const [roomData, setRoomData] = useState([]);
    const toggle = (id) => {
        if (open === id) {
        setOpen();
        } else {
        setOpen(id);
        }
    };

    const fetchRoomLogs = async()=>{
        const resp = await getRoomLogs(props.roomId)
        if(resp.data.success){
            setRoomData(resp.data.result)
        }
    }

  return (
    <Row className='mb-4'>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.0/dist/css/bootstrap.min.css"/>
        <Col className='ml-2 mr-2'>
            <Accordion open={open} toggle={toggle}>
                {roomData && roomData.map((logItem,logIndex)=>{
                    return <AccordionItem key={logItem._id}>
                        <AccordionHeader targetId={String(logIndex + 1)}>{logItem.title + ' ' + logItem.createdAt.split('.')[0]}</AccordionHeader>
                        <AccordionBody accordionId={String(logIndex + 1)}>
                            <Row>
                                <Col>
                                    {logItem.userId?.name && <p><strong>Employee:</strong> {logItem.userId.name} </p>}
                                    {logItem.deduction && <p><strong>Deduction:</strong> {logItem.deduction} €</p>}
                                </Col>
                                <Col>
                                    {logItem.managerId?.name && <p><strong>Manager:</strong> {logItem.managerId.name} </p>}
                                    {logItem.about && <p><strong>Info:</strong> {logItem.about} </p>}
                                </Col>
                            </Row>
                        </AccordionBody>
                    </AccordionItem>

                })}
            </Accordion>
        </Col>
    </Row>
  )
}

export default RoomLogs